import { render } from "./Terms.vue?vue&type=template&id=5f768eac"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
script.render = render

export default script